import React from 'react'
import UserProfile from '../Models/UserProfile'

const LoggedContext = React.createContext(
    {
        username : '',
        tokenAPI:'',
        userProfile: new UserProfile(),
        selectedItem:null,
        selectedMenuItem:null,
        setUserToken: (UserName,TokenAPI) => {
          this.setState({username: UserName, tokenAPI:TokenAPI})
        },
        setUserProfile:(user) => {
          this.setState({userProfile: user})
        },
        setSelectedItem:(item) => {
          this.setState({selectedItem: item})
        },
        setSelectedMenuItem:(item) => {
          this.setState({selectedMenuItem: item})
        }
})

export const LoggedProvider = LoggedContext.Provider
export const LoggedConsumer = LoggedContext.Consumer
export default LoggedContext